<div class="contractor-details-overlay">
  <div class="details-header">
    <h2>Contractor Details</h2>

    <button type="button" class="close-btn" (click)="closeOverlay()">
      <span class="material-icons">close</span>
    </button>
  </div>

  <div class="details-body" *ngIf="!isLoading && registration">
    <div class="title-row">
      <h1>Compliance Documents</h1>
      <span>{{ registration.contractor?.businessName }}</span>

      <wm-common-button
        class="new-registration-btn"
        [data]="{
          text: 'NEW REGISTRATION',
          variant: 'raised',
          type: 'button',
          onClick: newRegistration.bind(this)
        }"
      ></wm-common-button>
    </div>

    <section class="registration-detail-card">
      <div class="registration-title-row">
        <h3>
          {{ registration.type?.name }}
          <span class="status-badge">
            {{ RegistrationStatus[registration.status] }}
          </span>
        </h3>
      </div>

      <div class="registration-details-grid">
        <div class="detail-field">
          <label>Registered On</label>
          <span>{{ registration.registeredOnString || '-' }}</span>
        </div>

        <div class="detail-field">
          <label>Approved On</label>
          <span>{{ registration.approvedOnString || '-' }}</span>
        </div>

        <div class="detail-field">
          <label>Effective On</label>
          <span>{{ registration.effectiveOnString || '-' }}</span>
        </div>

        <div class="detail-field">
          <label>Expires On</label>
          <span>{{ registration.expiresOnString || '-' }}</span>
        </div>

        <div class="detail-field">
          <label>Payment Method</label>
          <span>{{ registration.paymentRequest?.paymentMethod || '-' }}</span>
        </div>

        <div class="detail-field">
          <label>Payment Amount</label>
          <span>
            {{
              registration.paymentRequest?.requestedAmount
                ? (registration.paymentRequest?.requestedAmount | currency)
                : '-'
            }}
          </span>
        </div>
      </div>

      <a
        class="certificate-link"
        *ngIf="registration.certificateDocument"
        [href]="getAzureDocumentPath(registration.certificateDocument)"
        target="_blank"
      >
        View Certificate
      </a>
    </section>

    <section
      class="details-section"
      *ngIf="contractorRequirementFields?.length"
    >
      <h3>
        Contractor Requirements
      </h3>

      <wm-contractor-custom-field-list
        [customFields]="contractorRequirementFields"
        [form]="contractorForm"
        #customFields
      ></wm-contractor-custom-field-list>

      <div class="requirement-save-row">
        <wm-common-button
          class="section-save-btn"
          [data]="{
            text: savingContractorRequirements ? 'SAVING...' : 'SAVE',
            variant: 'raised',
            type: 'button',
            disabled: contractorForm.invalid || savingContractorRequirements,
            onClick: saveContractorDetails.bind(this)
          }"
        ></wm-common-button>
      </div>
    </section>

    <section
      class="details-section"
      *ngIf="registrationRequirementFields?.length"
    >
      <h3>Registration Requirements</h3>

      <wm-contractor-custom-field-list
        [customFields]="registrationRequirementFields"
        [form]="rcfForm"
        #registrationCustomFields
      ></wm-contractor-custom-field-list>

      <div class="requirement-save-row">
        <wm-common-button
          class="section-save-btn"
          [data]="{
            text: savingRegistrationRequirements ? 'SAVING...' : 'SAVE',
            variant: 'raised',
            type: 'button',
            disabled: rcfForm.invalid || savingRegistrationRequirements,
            onClick: saveRegistrationCustomFields.bind(this)
          }"
        ></wm-common-button>
      </div>
    </section>

    <section class="details-section">
      <div class="section-header">
        <div>
          <h3>Registration Documents</h3>
          <p>Use the upload button to add new docs</p>
        </div>
      </div>

      <wm-contractor-document-list
        [documents]="documents"
        [parentId]="registrationId"
        (saved)="saveDocument($event)"
        (deleted)="deleteDocument($event)"
        (added)="addNewDocuments($event)"
      ></wm-contractor-document-list>
    </section>

    <section class="details-section">
      <div class="section-header">
        <div>
          <h3>Contractor Documents</h3>
          <p>Use the upload button to add new docs</p>
        </div>
      </div>

      <wm-contractor-document-list
        [documents]="contractorDocuments"
        [parentId]="contractorId"
        (saved)="saveContractorDocument($event)"
        (deleted)="deleteContractorDocument($event)"
        (added)="addNewContractorDocuments($event)"
      ></wm-contractor-document-list>
    </section>

    <section
      class="details-section additional-fields-section"
      *ngIf="registration.customFields && registration.customFields.length > 0"
    >
      <h3>Additional Fields</h3>

      <wm-contractor-custom-field-list
        [customFields]="registration.customFields"
        [form]="form"
        [isReadOnly]="true"
      ></wm-contractor-custom-field-list>
    </section>
  </div>

  <div class="loading-text" *ngIf="isLoading">
    Loading contractor details...
  </div>
</div>
